import axios from 'axios'

import { CART as ENDPOINT} from '../common/endpoints'
import { error, success, warning } from '../main/toast-notifications'
import { t } from '../main/i18n'
import { updateMiniCart } from '../main/cart'

const	product = window.motostorm
const buttonsAddToCart = document.querySelectorAll('.j-add-to-cart')

const addToCartWithToken = (evt) => {
	
	evt.preventDefault()
	grecaptcha.ready(function() {
		grecaptcha.execute('6Ldtk0gfAAAAACPWMoSiKjmoEZ68JbjcdCT9Vqo-', {action: 'submit'}).then(function(token) {

			const tokenField = document.querySelector('.g-recaptcha-token')
			tokenField.value = token
			addToCart()

		})
	})
}

const addToCart = async () => {
	
	const qty = document.getElementById('id-quantity')?.value
	const size = document.getElementById('sizes-select')?.value
	const token = document.querySelector('.g-recaptcha-token')?.value
	
	// quantity and size are mandatory params
	if (!qty || !size) {
		warning(t('qty-size-mandatory'))
		return
	}

	// disable and prevent additional submissions
	buttonsAddToCart.forEach(el => el.setAttribute('disabled', true))

	try {
		const res = await axios.post(ENDPOINT, {
			data: {
				token,
				qty,
				size,
				...product,
			},
		})
		updateMiniCart(res.data)
		const cartPreview = document.querySelector('.c-cart-preview')
		cartPreview.classList.add('is-active')
		setTimeout(
			() => cartPreview.classList.remove('is-active')
		, 3000)
		//success(t('add-to-cart-success'))
	} catch (e) {
		error(t('add-to-cart-error'))
	}
	// restore buttons
	buttonsAddToCart.forEach(el => el.removeAttribute('disabled'))	
}

// setup events
buttonsAddToCart.forEach( (button) => {
	button.addEventListener('click', addToCartWithToken )
})
